export default function ParseJson(logString) {
  if (!logString) return null;

  try {
    return JSON.parse(logString);
  } catch (error) {
    try {
      let cleanedLog = logString.trim();

      if (cleanedLog.includes("mensagem =")) {
        const match = cleanedLog.match(/{\s*mensagem\s*=\s*({.*})\s*}/s);
        if (match && match[1]) {
          cleanedLog = match[1];
        }
      }

      cleanedLog = cleanedLog.replace(/\r\n/g, "\\n");
      return JSON.parse(cleanedLog);
    } catch (secondError) {
      return {
        error: "Formato de log não suportado",
        originalContent: logString,
        tip: "Este log parece estar em formato C# em vez de JSON válido",
      };
    }
  }
}
